import { Action } from 'redux';
import { UserModel } from '../../../api/authentication/authentication.types';
import { SupplierModel } from '../../../api/admin/admin.types';

export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL';
export const TOKEN_VALID = 'TOKEN_VALID';
export const TOKEN_INVALID = 'TOKEN_INVALID';
export const STORE_ACTIVE_SUPPLIER = 'STORE_ACTIVE_SUPPLIER';
export const STORE_NEW_TOKEN = 'STORE_NEW_TOKEN';
export const STORE_USER_CHANGES = 'STORE_USER_CHANGES';

export interface AuthenticationState {
  token: string | null;
  user: UserModel | null;
  loginFailed: boolean;
  suppliers: SupplierModel[];
  activeSupplier: SupplierModel | null;
}

export interface StoreUserChangesAction extends Action {
  type: typeof STORE_USER_CHANGES;
  payload: {
    user: UserModel;
  };
}

export interface LoginAction extends Action {
  type: typeof LOGIN_SUCCESSFUL | typeof LOGIN_FAILED;
  payload?: {
    token: string;
    user: UserModel;
    suppliers: SupplierModel[];
    activeSupplier: SupplierModel;
  };
}

export interface LogoutAction extends Action {
  type: typeof LOGOUT_SUCCESSFUL;
}

export interface ValidateTokenAction extends Action {
  type: typeof TOKEN_VALID | typeof TOKEN_INVALID;
}

export interface StoreActiveSupplierAction extends Action {
  type: typeof STORE_ACTIVE_SUPPLIER;
  payload: {
    activeSupplier: SupplierModel;
  };
}

export interface StoreNewTokenAction extends Action {
  type: typeof STORE_NEW_TOKEN;
  payload: {
    token: string;
  };
}


export type AuthenticationActionTypes =
  LoginAction
  | LogoutAction
  | ValidateTokenAction
  | StoreActiveSupplierAction
  | StoreNewTokenAction
  | StoreUserChangesAction;
